module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/11-5e1c012a89b9d992fb8a7efd0b90d954.jpg";